import clsx from 'clsx';
import React from 'react';

import styles from './Snow.module.css';

export function Snow() {
  const stage = React.useMemo(() => {
    // Stage 1 = Dec 15 to Dec 31
    // Stage 2 = Dec 24, 25, 26
    const now = new Date();
    if (now.getMonth() === 11) {
      const day = now.getDate();
      if (day >= 24 && day <= 26) {
        return 2;
      }
      if (day >= 15) {
        return 1;
      }
    }
    return 0;
  }, []);

  if (!stage) {
    return null;
  }

  const nodes: React.ReactNode[] = [];
  for (let i = 0; i < 100; i++) {
    nodes.push(<Flake key={nodes.length} />);
  }

  if (stage === 2) {
    // Add some extra flakes for stage 2
    for (let i = 0; i < 50; i++) {
      nodes.push(<Flake key={nodes.length} />);
    }

    nodes.push(<div key="tree" className={clsx(styles.Fullscreen, styles.Tree)}></div>);
  }

  return <div className={clsx(styles.Fullscreen, styles.SnowContainer)}>{nodes}</div>;
}

function Flake() {
  const { style, char } = React.useMemo(() => {
    let fontSize = random(25, 50);
    let char = '.';

    // eslint-disable-next-line react-hooks/purity
    if (Math.random() > 0.7) {
      fontSize = random(10, 25);
      char = '*';
    }

    const style: React.CSSProperties = {
      top: `-${random(1, 100)}%`,
      left: `${random(1, 100)}%`,
      fontSize: `${fontSize}px`,
      animationDuration: `${random(10, 20)}s`,
    };
    return { style, char };
  }, []);

  return (
    <div style={style} className={styles.Snow}>
      {char}
    </div>
  );
}

function random(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min)) + min;
}
